export class CreateInvoiceFormRequest {
  CreditorUri: number;
  DocumentTypeCode: string;
  DocumentReference: string;
  DocumentDate: Date;
  NetAmount: number;
  VatRateCode: string;
  VatAmount: number;
  GrossAmount: number;
  BillingAddress: string;
  ServicesRendered: string;
  FormDesignId: number;
  PurchaseOrderId: string;
  ContractId: string;
  FromDate: Date;
  ToDate: Date;
}
